/* io-cart.js - Dynamic Shipping Bar + Empty State + Visibility Manager */

document.addEventListener('DOMContentLoaded', function () {
  
  /* =============================================================
     1. DYNAMIC STATE MANAGER
     ============================================================= */

  const FREE_SHIPPING_THRESHOLD = 100; // in cents
  let latestCartCache = null;

  // We only show the empty state if we've confirmed it via a fresh /cart.js call
  let cartConfirmedEmpty = false;

  // --- A. TOGGLE VIEW FUNCTION ---
  function toggleDrawerState(cart) {
    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer || !cart) return;

    // Never force "empty" unless confirmed from a real fetch
    if (cart.item_count === 0 && !cartConfirmedEmpty) {
      cartDrawer.classList.remove('drawer--is-empty');
      cartDrawer.classList.add('drawer--has-items');
      return;
    }

    if (cart.item_count > 0) {
      cartDrawer.classList.remove('drawer--is-empty');
      cartDrawer.classList.add('drawer--has-items');
    } else {
      cartDrawer.classList.remove('drawer--has-items');
      cartDrawer.classList.add('drawer--is-empty');
    }
  }

  // --- B. SHIPPING BAR UPDATE (Excludes Gift Cards) ---
  function updateShippingBar(cart) {
    const barFill = document.querySelector('.io-bar-fill');
    const barText = document.querySelector('.io-bar-text');

    if (!barFill || !barText) return;

    // 1. Calculate Eligible Total (Skipping Gift Cards)
    let eligibleTotal = 0;
    
    if (cart.items) {
      cart.items.forEach(item => {
        const typeStr = (item.product_type || "").toLowerCase();
        const titleStr = (item.title || "").toLowerCase();
        
        // identifying gift cards by type or title
        const isGiftCard = typeStr.includes('gift card') || titleStr.includes('gift card');
        
        if (!isGiftCard) {
          eligibleTotal += item.final_line_price;
        }
      });
    }

    // 2. Calculate Progress
    const percent = Math.min((eligibleTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
    const remainingCents = FREE_SHIPPING_THRESHOLD - eligibleTotal;
    const remainingDollars = (remainingCents / 100).toFixed(2);

    // 3. Update UI
    let newText = "";
    if (eligibleTotal >= FREE_SHIPPING_THRESHOLD) {
      newText = "You've unlocked <strong>FREE SHIPPING!</strong>";
    } else {
      newText = `Add <strong>$${remainingDollars}</strong> to unlock Free Shipping!`;
    }

    if (barFill.style.width !== `${percent}%`) barFill.style.width = `${percent}%`;
    if (barText.innerHTML.trim() !== newText.trim()) barText.innerHTML = newText;
  }
  
  function updateHeaderBubble(cart) {
    const bubble = document.getElementById('CartCount') || document.querySelector('.cart-link__bubble');
    if (bubble) {
      let realCount = cart.item_count;
      const currentText = bubble.textContent.trim();
      const newText = realCount.toString();
      
      if (realCount > 0) {
         if (currentText !== newText) bubble.textContent = newText;
         bubble.classList.add('cart-link__bubble--visible');
         bubble.style.display = 'flex';
      } else {
         bubble.classList.remove('cart-link__bubble--visible');
         bubble.style.display = 'none';
      }
    }
  }

  // --- C. MASTER UPDATE FUNCTION ---
  function updateAllCartElements(cart) {
    if (!cart) return;

    latestCartCache = cart;
    cartConfirmedEmpty = (cart.item_count === 0);

    toggleDrawerState(cart);
    updateShippingBar(cart);
    updateHeaderBubble(cart);
  }

  async function syncCart() {
    try {
      const cart = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(r => r.json());

      updateAllCartElements(cart);
    } catch (err) {
      // If we can't sync, do NOT force empty state.
      if (latestCartCache) {
        toggleDrawerState(latestCartCache);
        updateShippingBar(latestCartCache);
      }
      console.warn('[io-cart] cart sync failed', err);
    }
  }
  
  /* =============================================================
     2. EVENT LISTENERS
     ============================================================= */
  
  /* =============================================================
     2.5. BFCACHE / BACK BUTTON RESYNC
     ============================================================= */

  // Fires when returning via Back/Forward (including bfcache restores)
  window.addEventListener('pageshow', function (event) {
    syncCart();
  });

  // Optional: also resync when tab becomes visible again (helps iOS Safari edge cases)
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      syncCart();
    }
  });

  // Theme-standard event
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      updateAllCartElements(evt.detail.cart);
    } else {
      syncCart();
    }
  });

  // Drawer open/close scroll lock
  document.addEventListener('drawer:open', function () {
    document.body.classList.add('no-scroll');
    // Force a sync when drawer opens to ensure bar is up to date
    syncCart();
  });

  document.addEventListener('drawer:close', function () {
    document.body.classList.remove('no-scroll');
  });

  // Basic add-to-cart safety sync 
  document.body.addEventListener('submit', function (e) {
    if (e.target && e.target.action && e.target.action.includes('/cart/add')) {
      // We removed stopImmediatePropagation to allow the theme to handle the open event
      setTimeout(syncCart, 400);
      setTimeout(syncCart, 1200);
    }
  });

  // MutationObserver: when drawer HTML changes, re-sync the real cart
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    let drawerSyncTimer = null;

    const observer = new MutationObserver(function () {
      if (drawerSyncTimer) clearTimeout(drawerSyncTimer);
      drawerSyncTimer = setTimeout(syncCart, 150);
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  /* =============================================================
     3. INITIAL LOAD
     ============================================================= */
  syncCart();

});